import { render, staticRenderFns } from "./borrowSuccess.vue?vue&type=template&id=02aead02&scoped=true&"
import script from "./borrowSuccess.vue?vue&type=script&lang=js&"
export * from "./borrowSuccess.vue?vue&type=script&lang=js&"
import style0 from "./borrowSuccess.vue?vue&type=style&index=0&id=02aead02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02aead02",
  null
  
)

export default component.exports